import FaqContainer from './FaqContainer'
import s from './Faq.less'
import FaqItem from './FaqItem'
import React from 'react'
import { insertLinkInText } from './faq.helpers'
import { replaceKeysInString } from '../../../utils/string'
import { useSelector } from 'react-redux'
import { selectCurrentHistoryFullRoute } from '../../../store/history/history.selectors'
import { selectSeoFaqData } from '../../../store/seo/seo.selectors'
import useErrorBoundaryCallback from '../../utils/useErrorBoundaryCallback'

const Faq = ({ faqParams = {}, impressionDataTag, clickDataTag, noTitle = false }) => {
  const currentRouteURL = useSelector(selectCurrentHistoryFullRoute)
  const { title, text, qa } = useSelector(selectSeoFaqData)

  const insertFaqParams = useErrorBoundaryCallback(text => replaceKeysInString(text, faqParams), [faqParams])

  if (!qa) return <></>

  return (
    <FaqContainer impressionDataTag={impressionDataTag}>
      {title && !noTitle && <h2 className={s.title}>{insertFaqParams(title)}</h2>}
      {text && <div className={s.text}>{insertFaqParams(text)}</div>}
      {qa.map(({ question, answer }, index) => {
        const computedAnswer = insertLinkInText({
          txt: insertFaqParams(answer),
          currentRouteURL
        })

        return (
          <FaqItem
            key={index}
            question={insertFaqParams(question)}
            answer={computedAnswer}
            clickDataTag={clickDataTag}
          />
        )
      })}
    </FaqContainer>
  )
}

export default Faq
